// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabs-container {
  position: relative;
  display: flex;
  align-items: center;
}
.tabs-container .tabs-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
}
.tabs-container .tabs-list-wrapper {
  overflow: hidden;
  flex-grow: 1;
}
.tabs-container .tabs-list-comp {
  display: flex;
  overflow-x: auto;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  white-space: nowrap;
  padding: 0;
  margin: 0;
}
.tabs-container .tabs-list-comp::-webkit-scrollbar {
  display: none;
}
.tabs-container .tabs-list-comp .tab-item {
  flex: 0 0 auto;
  padding: 24px;
  cursor: pointer;
  text-align: left;
  border-bottom: 1px solid lightgray;
}
.tabs-container .tabs-list-comp .tab-item:hover {
  background-color: #f8f9fa;
}
.tabs-container .tabs-list-comp .tab-item.active {
  border-bottom: 2px solid #4403bf;
}
.tabs-container .tabs-list-comp .tab-item .title-styles {
  font-family: "Plus Jakarta Sans";
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  color: #6e7485;
}
.tabs-container .tabs-list-comp .tab-item .title-styles.active {
  color: #1d2026;
}
.tabs-container .more-tabs-list-comp {
  display: flex;
  overflow-x: auto !important;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch !important;
  white-space: nowrap;
  padding: 0;
  margin: 0;
  scrollbar-width: none;
}
.tabs-container .more-tabs-list-comp::-webkit-scrollbar {
  display: none !important;
}
.tabs-container .arrow {
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
}
.tabs-container .arrow .arrow-icon {
  width: 100%;
  height: 100%;
  background: white;
}
.tabs-container .left-arrow {
  left: 0px;
}
.tabs-container .left-arrow .arrow-icon {
  transform: rotate(-180deg);
  background: white;
}
.tabs-container .right-arrow {
  right: 0px;
}
@media (min-width: 769px) {
  .tabs-container .arrow {
    display: none;
  }
  .tabs-container .tabs-list-comp {
    overflow: hidden;
    justify-content: space-around;
  }
  .tabs-container .tabs-list-comp .tab-item {
    flex: 1 1 auto;
  }
}

@media (max-width: 1024px) and (min-width: 769px) {
  .tabs-list-comp .tab-item {
    padding: 12px !important;
  }
  .tabs-list-comp .tab-item .title-styles {
    font-size: 12px !important;
    line-height: 18px !important;
  }
  .arrow {
    width: 20px !important;
    height: 20px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Classroom/TabsComponent.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AACJ;AAEE;EACE,gBAAA;EACA,YAAA;AAAJ;AAGE;EACE,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,iCAAA;EACA,mBAAA;EACA,UAAA;EACA,SAAA;AADJ;AAGI;EACE,aAAA;AADN;AAII;EACE,cAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;AAFN;AAIM;EACE,yBAAA;AAFR;AAKM;EACE,gCAAA;AAHR;AAMM;EACE,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAJR;AAMQ;EACE,cAAA;AAJV;AAUE;EACE,aAAA;EACA,2BAAA;EACA,uBAAA;EACA,4CAAA;EACA,mBAAA;EACA,UAAA;EACA,SAAA;EACA,qBAAA;AARJ;AAUI;EACE,wBAAA;AARN;AAWE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;AATJ;AAWI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AATN;AAaE;EACE,SAAA;AAXJ;AAaI;EACE,0BAAA;EACA,iBAAA;AAXN;AAeE;EACE,UAAA;AAbJ;AAgBE;EACE;IACE,aAAA;EAdJ;EAiBE;IACE,gBAAA;IACA,6BAAA;EAfJ;EAiBI;IACE,cAAA;EAfN;AACF;;AAoBA;EAEI;IACE,wBAAA;EAlBJ;EAmBI;IACE,0BAAA;IACA,4BAAA;EAjBN;EAqBA;IACE,sBAAA;IACA,uBAAA;EAnBF;AACF","sourcesContent":[".tabs-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n\n  .tabs-wrapper {\n    display: flex;\n    align-items: center;\n    width: 100%;\n  }\n\n  .tabs-list-wrapper {\n    overflow: hidden;\n    flex-grow: 1;\n  }\n\n  .tabs-list-comp {\n    display: flex;\n    overflow-x: auto;\n    scroll-behavior: smooth;\n    -webkit-overflow-scrolling: touch;\n    white-space: nowrap;\n    padding: 0;\n    margin: 0;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n\n    .tab-item {\n      flex: 0 0 auto;\n      padding: 24px;\n      cursor: pointer;\n      text-align: left;\n      border-bottom: 1px solid lightgray;\n\n      &:hover {\n        background-color: #f8f9fa;\n      }\n\n      &.active {\n        border-bottom: 2px solid #4403bf;\n      }\n\n      .title-styles {\n        font-family: \"Plus Jakarta Sans\";\n        font-size: 16px;\n        font-weight: 500;\n        line-height: 22px;\n        color: #6e7485;\n\n        &.active {\n          color: #1d2026;\n        }\n      }\n    }\n  }\n\n  .more-tabs-list-comp {\n    display: flex;\n    overflow-x: auto !important;\n    scroll-behavior: smooth;\n    -webkit-overflow-scrolling: touch !important;\n    white-space: nowrap;\n    padding: 0;\n    margin: 0;\n    scrollbar-width: none;\n\n    &::-webkit-scrollbar {\n      display: none !important;\n    }\n  }\n  .arrow {\n    width: 24px;\n    height: 24px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    z-index: 2;\n\n    .arrow-icon {\n      width: 100%;\n      height: 100%;\n      background: white;\n    }\n  }\n\n  .left-arrow {\n    left: 0px;\n\n    .arrow-icon {\n      transform: rotate(-180deg);\n      background: white;\n    }\n  }\n\n  .right-arrow {\n    right: 0px;\n  }\n\n  @media (min-width: 769px) {\n    .arrow {\n      display: none;\n    }\n\n    .tabs-list-comp {\n      overflow: hidden;\n      justify-content: space-around;\n\n      .tab-item {\n        flex: 1 1 auto;\n      }\n    }\n  }\n}\n\n@media (max-width: 1024px) and (min-width: 769px) {\n  .tabs-list-comp {\n    .tab-item {\n      padding: 12px !important;\n      .title-styles {\n        font-size: 12px !important;\n        line-height: 18px !important;\n      }\n    }\n  }\n  .arrow {\n    width: 20px !important;\n    height: 20px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
